export default "__VITE_ASSET__CJvduVC___"